/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import eliIllustration from '../../../../../../assets/student-training/pypi/section3-img2.png';
import SafeBrowsing from '../../components/SafeBrowsing';
import icon1 from '../../../../../../assets/student-training/pypi/section3-step1.png';
import icon2 from '../../../../../../assets/student-training/pypi/section3-step2.png';
import icon3 from '../../../../../../assets/student-training/pypi/section3-step3.png';
import icon4 from '../../../../../../assets/student-training/pypi/section3-step4.png';

const iconMap: Record<number, string> = {
  1: icon1,
  2: icon2,
  3: icon3,
  4: icon4,
};

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const [activatedSet, setActivatedSet] = React.useState<Set<number>>(
    new Set([0])
  );

  const handleBubbleHover = React.useCallback((index: number) => {
    setActivatedSet((prev) => {
      const newSet = new Set(prev);
      newSet.add(index);
      if (newSet.size === paragraphsSettings?.section3Items?.length) {
        console.log(111);
      }
      return newSet;
    });
  }, []);

  const handleComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-pypi-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-2">
      <ExpandableListIllustration
        subTitle={paragraphsSettings?.section2Title}
        description={paragraphsSettings?.section2Desc}
        illustration={<img src={eliIllustration} alt="" />}
        items={paragraphsSettings?.section2Items}
        id="student-training-pypi-section2-1"
        onComplete={handleComplete}
      />
      <div className="social-oversharing-section">
        <h2 className="oversharing-title">
          {paragraphsSettings?.section3Title}
        </h2>
        <div className="oversharing-content">
          <div className="oversharing-center active">
            <div
              className="center-text"
              dangerouslySetInnerHTML={{
                __html: paragraphsSettings?.section3Items?.[0],
              }}
            />
          </div>
          {paragraphsSettings?.section3Items
            ?.slice(1)
            ?.map((item: string, index: number) => {
              const realIndex = index + 1;
              return (
                <div
                  key={realIndex}
                  className={`oversharing-bubble bubble-${index} ${
                    activatedSet.has(realIndex) ? 'active' : ''
                  }`}
                  onMouseEnter={() => handleBubbleHover(realIndex)}
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              );
            })}
        </div>
      </div>
      <SafeBrowsing
        title={paragraphsSettings?.section4MainTitle}
        subTitle={''}
        description={''}
        sectionTitle={''}
        sectionDescription={''}
        slides={paragraphsSettings?.section4Items}
        icons={iconMap}
      />
    </div>
  );
};

export default Section2;
